import React, { Fragment,useEffect} from 'react'
import {Card,Col,Row,Container} from 'reactstrap'
import ReactApexChart from 'react-apexcharts';

export const ComponentDetailBranchs = (props) => {

    const {options,series,sum_branches_recolected,listBranchesTree,handleGeneralPatients,classifications,typePeriod,branches_programming,sumre} = props;
    console.log("🚀 ~ ComponentDetailBranchs ~ sum_branches_recolected:", sum_branches_recolected)
 

    useEffect(() => {
    if (listBranchesTree?.length) {
      const branchWithAmount = listBranchesTree
        .flatMap(branch => branch.children) 
        .find(child => child.amount > 0);   

      if (branchWithAmount) {
        handleGeneralPatients(branchWithAmount.id, typePeriod);
      }
    }
  }, [listBranchesTree, typePeriod,]);

  const branchesProgrammingNumber = parseInt(branches_programming[0].split(':')[1].trim(), 10);
  console.log("🚀 ~ ComponentDetailBranchs ~ branchesProgrammingNumber:", branchesProgrammingNumber)

const percentage = (sum_branches_recolected / branchesProgrammingNumber) * 100;



    return (
        <Fragment>
        <Container fluid={true} className='p-l-0 p-r-0'>
          {
            //!DETAIL AMOUNT BRANCHS
          }
         
          <Col sm="12" className=' p-r-0' >
         <Row className='pt-3'>
        <Col sm="2" className="d-flex flex-column align-items-center">
          <ul className="mb-2"> 
            <i 
              className={classifications === 'muy alto' ? "fa fa-calendar-o f-48 calender-deatil-branches-alto-m" : "fa fa-calendar-o f-30 calender-deatil-branches-alto-m"}
              style={classifications === 'muy alto' ? {} : { filter: 'blur(1px)' }} 
              title="Muy Alto(Porcetanje mayor al 90%)"
            ></i>
          </ul>

          {/* Alto */}
          <ul className="mb-2">
            <i 
              className={classifications === 'alto' ? "fa fa-calendar-o f-48 calender-deatil-branches-alto" : "fa fa-calendar-o f-30 calender-deatil-branches-alto"} 
              style={classifications === 'alto' ? {} : { filter: 'blur(1px)' }}
              title="Alto (Porcentaje del 70% al 89.99%) "
            ></i>
          </ul>

          {/* Medio */}
          <ul className="mb-2">
            <i 
              className={classifications === 'medio' ? "fa fa-calendar-o f-48 calender-deatil-branches-medio" : "fa fa-calendar-o f-30 calender-deatil-branches-medio"} 
              style={classifications === 'medio' ? {} : { filter: 'blur(1px)' }} 
              title="Medio ( porcentaje al  40% y 60.99%)"
            ></i>
          </ul>

          {/* Medio Bajo */}
          <ul className="mb-2">
            <i 
              className={classifications === 'medio bajo' ? "fa fa-calendar-o f-48 calender-deatil-branches-medio-b" : "fa fa-calendar-o f-30 calender-deatil-branches-medio-b"} 
              style={classifications === 'medio bajo' ? {} : { filter: 'blur(1px)' }} 
              title="Medio Bajo (Porcentaje entre el 10% y 40%) "
            ></i>
          </ul>

          {/* Bajo */}
          <ul className="mb-2">
            <i 
              className={classifications === 'bajo' ? "fa fa-calendar-o f-48 calender-deatil-branches calender-deatil-branches-bajo" : "fa fa-calendar-o f-30 calender-deatil-branches calender-deatil-branches-bajo"} 
              style={classifications === 'bajo' ? {} : { filter: 'blur(1px)' }} 
              title="Bajo (Porcentaje entre el 10% y 40%) "
            ></i>
          </ul>

          {/* Nada */}
          <ul className="mb-2">
            <i 
              className={classifications === 'nada' ? "fa fa-calendar-o f-48 calender-deatil-branches-nada" : "fa fa-calendar-o f-30 calender-deatil-branches-nada"} 
              style={classifications === 'nada' ? {} : { filter: 'blur(1px)' }} 
              title="Nada (Porcentaje al 0%)"
            ></i>
          </ul>
        </Col>



          {/* Columna para el gráfico y explicación */}
          <Col sm="10" style={{ width: '100%' }}>
            {/* Título de porcentaje con estilo destacado */}
            <div className="text-center ">
              <h6 style={{ color: "#002940", fontWeight: "bold" }}>Porcentaje Recolectado</h6>
              <label style={{ color: "#007bff", fontSize: "18px" }}>{(percentage).toFixed(2)}%</label>
            </div>
          

            <ReactApexChart options={options} series={series} type="bar" height={100} />

            <div >
              <p>{`Has recolectado ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(sum_branches_recolected)}. Esto está en la categoría '${classifications}', lo que indica un progreso ${classifications === 'medio' ? 'moderado' : 'bajo'} del monto programado de ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(branchesProgrammingNumber)}.`}</p>
            </div>
          </Col>
        </Row>


      
          </Col>

        </Container>   
        </Fragment>
    )
}
